/* eslint-disable react/jsx-pascal-case */
import { Step, StepLabel, Stepper, Drawer, Box, Divider } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import css from './styles.module.scss';
import { useLocation } from 'react-router-dom';
import { Step_1 } from '~/features/dashboard/components/add-deal/components/step-1';
import { Step_2 } from '~/features/dashboard/components/add-deal/components/step-2';
import { Step_3 } from '~/features/dashboard/components/add-deal/components/step-3';
import { Step_4 } from '~/features/dashboard/components/add-deal/components/step-4';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Step_5 } from '~/features/dashboard/components/add-deal/components/step-5';
import { Step_6 } from '~/features/dashboard/components/add-deal/components/step-6';
import { selectNewDeal, selectNewDealStep, selectIsDealEditing } from '~/features/dashboard/store/selectors';
import { newDealFormPrevStep, resetNewDealForm, editNewDealForm, isDealFormEditing } from '~/features/dashboard/store/actions';
import { NEW_DEAL_FORM_STEPS_COUNT } from '~/features/dashboard';
import { Step_7 } from '~/features/dashboard/components/add-deal/components/step-7/';
import { Button, Typography } from '@material-ui/core';
import { push } from 'connected-react-router';
import { makeStyles } from '@material-ui/core/styles';
import { StepIconProps } from '@material-ui/core/StepIcon';
import clsx from 'clsx';
import Check from '@material-ui/icons/Check';
import { DownloadButton } from '~/common/download-button';
import { DEAL_TODODRAWER } from '~/features/dashboard/components/todo-deal-drawer';
import { FindInPageOutlined } from '@material-ui/icons';
import { goToEditDealThunk } from '~/features/dashboard/store/actions.thunks';
import { axiosInstance } from '~/api/config/axios.config';
import { filter } from 'lodash';
import { LabelStepDeal } from '~/models/music/new-song/helpers';

interface MyDealsAddDealProps {}

interface noteData_props {
    id: number;
    gDealRef: string;
    notes: string;
    completed: number;
    isDelete: number;
}

export const AddDeal: React.FC<MyDealsAddDealProps> = () => {
    const newDealState = useSelector(selectNewDeal);
    const selectDealEditing = useSelector(selectIsDealEditing);
    const step = useSelector(selectNewDealStep);
    const [notesDrawer, setNotesDrawer] = useState(false);

    const [notesData, setNotesData] = React.useState<noteData_props[]>([]);
    const [toDoData, setToDosData] = React.useState<noteData_props[]>([]);

    const dispatch = useDispatch();
    const location = useLocation();

    // Navigate to Edit Deal page on page reload;
    useEffect(() => {
        if (!selectDealEditing && !newDealState) {
            // TODO: hot fix, must be refactored
            const parts = window.location.href.split('/');
            const dealId = parts.pop() || parts.pop(); // handle potential trailing slash
            if (dealId && dealId !== 'add-deal') {
                dispatch(isDealFormEditing(true));
                dispatch(goToEditDealThunk({ assetCode: dealId }));
            }
        }
    }, [selectDealEditing, newDealState]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (location.state === undefined) {
            dispatch(resetNewDealForm());
        }
    }, [dispatch, location]);

    const prevStep = useCallback(() => {
        dispatch(newDealFormPrevStep());
    }, [dispatch]);

    const gotoBack = () => {
        dispatch(push(`/creators-list/${newDealState?.projectId}/dashboard/deals/table/${newDealState?.contractRefNum}/details`));
    };
    const useQontoStepIconStyles = makeStyles({
        root: {
            color: '#eaeaf0',
            display: 'flex',
            height: 22,
            alignItems: 'center',
        },
        active: {
            color: 'var(--color-yellow-dark3)',
        },
        circle: {
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: 'currentColor',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        completed: {
            color: '#fff',
            backgroundColor: 'var(--color-yellow-dark3)',
            zIndex: 1,
            fontSize: 18,
            width: 40,
            height: 40,
            padding: 8,
            borderRadius: '100%',
        },
    });

    function QontoStepIcon(props: StepIconProps) {
        const classes = useQontoStepIconStyles();
        const { active, completed, icon } = props;

        return (
            <div
                className={clsx(classes.root, {
                    [classes.active]: active,
                })}
            >
                {completed ? (
                    <Check className={classes.completed} />
                ) : (
                    <div className={classes.circle}>
                        <span className={css.spanCircle}>{icon}</span>
                    </div>
                )}
            </div>
        );
    }

    const listInnerRef: any = React.useRef();

    useEffect(() => {
        if (newDealState) {
            // TODO: use selector
            axiosInstance.get('Catalogue/projectcreator/dealtodolist', { params: { gDealRef: newDealState.contractRefNum } }).then(async ({ data }: any) => {
                setToDosData(filter(data, ['isDelete', 0]));
            });
            axiosInstance.get('Catalogue/projectcreator/dealnoteslist', { params: { gDealRef: newDealState.contractRefNum } }).then(async ({ data }: any) => {
                setNotesData(filter(data, ['isDelete', 0]));
            });
        }
    }, [newDealState]);

    return (
        <div className={css.module}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <>
                    <Drawer variant="persistent" anchor={`right`} open={notesDrawer} id="drawer">
                        <div ref={listInnerRef} style={{ overflowY: 'scroll', overflowX: 'hidden', height: '100vh' }} className={css.rightdrawer}>
                            <Typography
                                className={css.closedrawer}
                                onClick={() => {
                                    setNotesDrawer(false);
                                }}
                            >
                                <Box component="span" fontSize={40} style={{ cursor: 'pointer' }}>
                                    &larr;
                                </Box>
                                <Box component="span" fontSize={15} className={css.closetitle}>
                                    Close
                                </Box>
                            </Typography>
                            <Divider />

                            {notesDrawer && (
                                <DEAL_TODODRAWER
                                    dealId={newDealState?.contractRefNum}
                                    notesData={notesData}
                                    toDoData={toDoData}
                                    setNotesData={setNotesData}
                                    setToDosData={setToDosData}
                                />
                            )}
                        </div>
                    </Drawer>
                    <div className={css.steppermainouter}>
                        {newDealState?.contractRefNum && (
                            <Button
                                className={css.backbtncustom}
                                variant="contained"
                                color="secondary"
                                disableElevation
                                startIcon={<FindInPageOutlined />}
                                onClick={gotoBack}
                                title="Go to Deal"
                            />
                        )}
                        <Stepper alternativeLabel activeStep={step - 1}>
                            {Array.from({ length: NEW_DEAL_FORM_STEPS_COUNT }, () => '').map((_, index) => (
                                <Step
                                    key={index}
                                    onClick={() => {
                                        if (!newDealState?.contractRefNum) {
                                            return;
                                        }
                                        dispatch(editNewDealForm({ step: index }));
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <StepLabel StepIconComponent={QontoStepIcon}>{LabelStepDeal[index]}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        {newDealState?.contractRefNum && (
                            <div className={css.togglebtn}>
                                <DownloadButton onClick={() => setNotesDrawer(true)} className={css.downloadButton} buttonFor="save" />
                            </div>
                        )}
                    </div>
                    {step === 1 && <Step_1 />}
                    {step === 2 && <Step_2 prevStep={prevStep} />}
                    {step === 3 && <Step_3 prevStep={prevStep} />}
                    {step === 4 && <Step_4 prevStep={prevStep} />}
                    {step === 5 && <Step_5 prevStep={prevStep} />}
                    {step === 6 && <Step_6 prevStep={prevStep} />}
                    {step === 7 && <Step_7 prevStep={prevStep} />}
                </>
            </MuiPickersUtilsProvider>
        </div>
    );
};
